// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  instanceId: __t.string().name("instance_id"),
  mapId: __t.string().name("map_id"),
  channelId: __t.string().name("channel_id"),
  status: __t.string(),
  playerCount: __t.u32().name("player_count"),
  maxPlayers: __t.u32().name("max_players"),
  lastPopulationChangeAt: __t.timestamp().name("last_population_change_at"),
  markedForDeleteAt: __t.option(__t.timestamp()).name("marked_for_delete_at"),
  createdAt: __t.timestamp().name("created_at"),
});
